import { useMemo } from 'react';
import { CENTER_DOT_INDEX, DOT_STEP_REM, MAX_VISIBLE_DOTS } from '../utils/constants';

type UseCarouselDotsProps = {
    totalImages: number;
    activeImageIndex: number;
};

export const useCarouselDots = ({ totalImages, activeImageIndex }: UseCarouselDotsProps) => {
    const dotsTrackOffsetRem = useMemo(() => {
        if (totalImages <= MAX_VISIBLE_DOTS) return 0;

        let centerPosition: number;

        if (activeImageIndex <= 1) {
            centerPosition = CENTER_DOT_INDEX;
        } else if (activeImageIndex >= totalImages - 2) {
            centerPosition = totalImages - 3;
        } else {
            centerPosition = activeImageIndex;
        }

        return -(centerPosition - CENTER_DOT_INDEX) * DOT_STEP_REM;
    }, [totalImages, activeImageIndex]);

    const edgeDotIndices = useMemo(() => {
        if (totalImages <= MAX_VISIBLE_DOTS) return new Set<number>();

        const indices = new Set<number>();

        if (activeImageIndex <= 1) {
            indices.add(4);
        } else if (activeImageIndex >= totalImages - 2) {
            indices.add(totalImages - 5);
        } else {
            indices.add(activeImageIndex - 2);
            indices.add(activeImageIndex + 2);
        }

        return indices;
    }, [totalImages, activeImageIndex]);

    return {
        dotsTrackOffsetRem,
        edgeDotIndices,
    };
};
